import styled from '@emotion/styled';

import { hexToRgbMixin, linkWithUnderlineHover } from 'styles/mixins';

import Button from 'components/ui/Button';

const Wrapper = styled.div`
  padding: 1.5rem 0;
  background: ${(props) => props.theme.colorMono.black};
  font-size: 1.2rem;
  color: #f1c73d;
  text-align: center;

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 1rem;
    color: inherit;
  }
  p {
    margin-bottom: 1rem;
    white-space: break-spaces;
  }
  a {
    ${linkWithUnderlineHover('&', 1)};
  }
`;

const StyledButton = styled(Button)`
  background: #f1c73d;
  color: ${(props) => props.theme.mainColors.primary};
  text-transform: uppercase;

  &:focus,
  &:hover {
    background-color: ${hexToRgbMixin('#f1c73d', 0.9)};
  }
  &:active {
    background-color: ${hexToRgbMixin('#f1c73d', 0.9)};
  }
`;

export {
  Wrapper,
  StyledButton
};
